import { Host, h } from '@stencil/core';
export class AibaQuizQuestion {
  constructor() {
    this.total = 5;
    this.index = 1;
    this.data = undefined;
    this.classes = undefined;
    this.handlers = undefined;
  }
  watchPropHandler(newValue, oldValue) {
    if ((newValue === null || newValue === void 0 ? void 0 : newValue.questionText) !== (oldValue === null || oldValue === void 0 ? void 0 : oldValue.questionText)) {
      this.handlers && this.handlers.quizQuestionHandler && this.handlers.quizQuestionHandler(newValue === null || newValue === void 0 ? void 0 : newValue.questionText);
    }
  }
  componentDidLoad() {
    var _a;
    this.handlers && this.handlers.quizQuestionHandler && this.handlers.quizQuestionHandler((_a = this.data) === null || _a === void 0 ? void 0 : _a.questionText);
  }
  render() {
    if (typeof this.data === 'string') {
      if (this.data)
        this.data = JSON.parse(this.data);
    }
    return (h(Host, null, h("div", { class: `question-wrapper` }, this.data &&
      this.data.elements.map((element) => {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x;
        if (element.name === 'aiba-label' && ((_a = element === null || element === void 0 ? void 0 : element.data) === null || _a === void 0 ? void 0 : _a._id) === 'questionInfo') {
          return h("aiba-label", Object.assign({}, element['data'], { innerHTML: (_b = this.data) === null || _b === void 0 ? void 0 : _b.questionInfo }));
        }
        if (element.name === 'aiba-label' && element.data.tag === 'p') {
          return h("aiba-label", Object.assign({}, element['data'], { text: `${element.data.prefix} ${this.index} ${element.data.suffix} ${this.total}` }));
        }
        else if (element.name === 'aiba-label' && ((_c = element === null || element === void 0 ? void 0 : element.data) === null || _c === void 0 ? void 0 : _c._id) === 'questionText') {
          return h("aiba-label", Object.assign({}, element['data'], { text: (_d = this.data) === null || _d === void 0 ? void 0 : _d.questionText, isMandatory: !!((_e = this.data) === null || _e === void 0 ? void 0 : _e.questionMandatory) }));
        }
        else if (element.name === 'aiba-label' && ((_f = element === null || element === void 0 ? void 0 : element.data) === null || _f === void 0 ? void 0 : _f._id) === 'questionTextInline') {
          return h("aiba-label", Object.assign({}, element['data'], { setInnerHTML: true, innerHTML: (_g = this.data) === null || _g === void 0 ? void 0 : _g.questionText, isMandatory: !!((_h = this.data) === null || _h === void 0 ? void 0 : _h.questionMandatory) }));
        }
        else if (element.name === 'aiba-label') {
          return h("aiba-label", Object.assign({}, element['data']));
        }
        if (element.name === 'aiba-progress-bar') {
          return h("aiba-progress-bar", { progress: Math.trunc((Number(this.index) / Number(this.total)) * 100), status: (element === null || element === void 0 ? void 0 : element.status) || 'low' });
        }
        if (element.name === 'aiba-alert' && this.data.questionInfo) {
          return h("aiba-alert", Object.assign({}, element['data'], { message: (_j = this.data) === null || _j === void 0 ? void 0 : _j.questionInfo }));
        }
        if (element.name === 'aiba-progress-dots') {
          return h("aiba-progress-dots", { total: Number(this.total), index: Number(this.index), handlers: this.handlers });
        }
        if (element.name === 'aiba-quiz-tips') {
          const questionIndex = (_k = this.data) === null || _k === void 0 ? void 0 : _k.questionId;
          return (((_l = this.data) === null || _l === void 0 ? void 0 : _l.quizTips) && (h("div", { class: "quiz-tips", "quiz-tips-index": questionIndex }, (_m = this.data) === null || _m === void 0 ? void 0 :
            _m.quizTips.elements.map(element => {
              if (element.name === 'aiba-button')
                return h("aiba-button", Object.assign({}, element['data'], { handleClick: (event) => this.handlers && this.handlers.quizTipClick(event, questionIndex) }));
            }), h("aiba-modal", { handlers: this.handlers, closeButtonData: (_q = (_p = (_o = this.data) === null || _o === void 0 ? void 0 : _o.quizTips) === null || _p === void 0 ? void 0 : _p.modalData) === null || _q === void 0 ? void 0 : _q.closeButtonData, modalPosition: (_t = (_s = (_r = this.data) === null || _r === void 0 ? void 0 : _r.quizTips) === null || _s === void 0 ? void 0 : _s.modalData) === null || _t === void 0 ? void 0 : _t.modalPosition }, (_x = (_w = (_v = (_u = this.data) === null || _u === void 0 ? void 0 : _u.quizTips) === null || _v === void 0 ? void 0 : _v.modalData) === null || _w === void 0 ? void 0 : _w.data) === null || _x === void 0 ? void 0 :
            _x.elements.map((element) => {
              if (element.name === 'aiba-generic-block')
                return h("aiba-generic-block", { data: element['data'] });
            }), h("div", { class: "background" })))));
        }
      }))));
  }
  static get is() { return "aiba-quiz-question"; }
  static get originalStyleUrls() {
    return {
      "$": ["aiba-quiz-question.scss"]
    };
  }
  static get styleUrls() {
    return {
      "$": ["aiba-quiz-question.css"]
    };
  }
  static get properties() {
    return {
      "total": {
        "type": "any",
        "mutable": false,
        "complexType": {
          "original": "any",
          "resolved": "any",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "total",
        "reflect": false,
        "defaultValue": "5"
      },
      "index": {
        "type": "any",
        "mutable": false,
        "complexType": {
          "original": "any",
          "resolved": "any",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "index",
        "reflect": false,
        "defaultValue": "1"
      },
      "data": {
        "type": "any",
        "mutable": false,
        "complexType": {
          "original": "any",
          "resolved": "any",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "data",
        "reflect": false
      },
      "classes": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": true,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "classes",
        "reflect": false
      },
      "handlers": {
        "type": "any",
        "mutable": false,
        "complexType": {
          "original": "any",
          "resolved": "any",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "handlers",
        "reflect": false
      }
    };
  }
  static get watchers() {
    return [{
        "propName": "data",
        "methodName": "watchPropHandler"
      }];
  }
}
//# sourceMappingURL=aiba-quiz-question.js.map
